export enum ServicesAndResourcesRadioItems {
  services = 'services',
  resources = 'resources',
  servicesAndResources = 'servicesAndResources'
}
